import styled from 'styled-components';
import { GlobalToken } from 'antd';

import { CustomThemeToken } from '@/theme';

export const ContentMetricItem = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  line-height: ${({ theme: { token } }) => token.lineHeight};
  font-size: ${({ theme: { token } }) => token.fontSize}px;

  .label {
  }

  .value-row {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .value {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightHeading4};
  }

  .unit {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
`;

export const DrawerMetricItem = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .label {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    text-transform: capitalize;
    line-height: ${({ theme: { token } }) => token.lineHeightSM};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .valueRow {
    display: flex;
    align-items: baseline;
  }

  .value {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .unit {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }
`;

export const FooterMetricItem = styled.div<{ theme: { token: CustomThemeToken } }>`
  display: flex;
  flex-direction: column;
  padding-right: ${({ theme: { token } }) => token.paddingXXS}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};

  .label {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    line-height: ${({ theme: { token } }) => token.lineHeight};
    text-align: left;
  }

  .value-row {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXXS / 2}px;
  }

  .value, .unit  {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorText};
  }
`;
